export default [
  "Machete",
  "Radiação",
  "Soco",
  "haltere",
  "Droga líquida",
  "Estilete",
  "Pistola",
  "Quarto trancado",
  "liberação de sangue",
  "Desmembramento",
  "Saco de plástico",
  "Chave Inglesa",
  "Ameba",
  "Água suja",
  "Atirador de elite",
  "Tijolo",
  "Martelo",
  "Mordida e desgaste",
  "Troféu",
  "E-Bike",
  "Cobra venenosa",
  "corrente de metal",
  "Vaso de planta",
  "fita Adesiva",
  "Corda",
  "Corrente elétrica",
  "Fio de metal",
  "Inanição",
  "Incêndio culposo",
  "Praga",
  "Fumaça",
  "cutelo",
  "Bastão de choque",
  "Machado",
  "Espátula",
  "explosivos",
  "Console de video game",
  "Gancho",
  "Pólvora",
  "Escorpião venenoso",
  "Patins de gelo",
  "Enterrado",
  "Faca e garfo",
  "injeção",
  "Fio",
  "Serra elétrica",
  "chicote",
  "Agulha envenenada",
  "Desarmado",
  "Cachecol",
  "Cirurgia",
  "Escultura",
  "Pedra",
  "Pontapé",
  "Arsênico",
  "Gás venenoso",
  "Afogar",
  "Droga em pó",
  "Pesticida",
  "Comprimido",
  "Produtos químicos",
  "garganta cortada",
  "Bastão",
  "Ácido sulfúrico",
  "Cadeira dobrável",
  "Empurrar",
  "liqüidificador",
  "Travesseiro",
  "Álcool",
  "overdose",
  "Tubo de aço",
  "Tesouras",
  "Candelabro",
  "Máquina",
  "Cachorro Louco",
  "Vírus",
  "Punhal",
  "Isqueiro",
  "Lâmina de barbear",
  "Toalha",
  "Cinto",
  "Vinho",
  "Querosene",
  "Mercúrio",
  "Broca",
  "Ponta de bambu",
  "Muleta",
  "droga ilegal"
];
